import * as Radix from "@radix-ui/themes";
import * as React from "react";
import Styles from "./RuthCard.module.css";
import { TierCard } from "./TierCard";
import * as Image from "~/image";

export type Props = {
  nimbusUrl: string;
};

export const RuthCard: React.FC<Props> = (props) => {
  return (
    <TierCard
      buttonHref={props.nimbusUrl}
      buttonText="Chat with Ruth for free"
      content={
        <Radix.Flex className={Styles.ruthContent}>
          <Radix.Text className={Styles.ruthTitle}>
            Meet Ruth, Vendr&apos;s AI negotiation agent
          </Radix.Text>
          <img
            alt="Ruth"
            src={Image.ruthOutlined}
            className={Styles.ruthImage}
          />
        </Radix.Flex>
      }
      description="Ruth, trained by Vendr's negotiation experts, provides:"
      features={[
        "Comprehensive software pricing benchmarks across dozens of spend categories",
        "Step-by-step negotiation insights and guidance",
      ]}
      name=""
    />
  );
};
